// nelo.mx sets its navigation in Inter at 14/500 with -0.025em, not in the display
// face: Inter Tight is 7% narrower and reads as a headline shrunk down at label sizes.
// Every navigation surface shares these two — the bar, the mega and the drawer used to
// carry four different registers between them.
export const NAV_LABEL = "font-text text-label tracking-tight font-medium"
export const NAV_ITEM = "font-text text-label tracking-tight font-normal"

export const NAV_ROW = `text-fg hover:bg-surface-subtle hover:text-fg-strong h-auto min-h-11 justify-start gap-300 rounded-none px-400 py-250 ${NAV_LABEL}`

export const NAV_EYEBROW = "font-display text-overline text-fg-subtle px-400 uppercase"

// "Electrónica, Audio y Video" is 26 characters — a shelf label, not a nav item. The
// bar and the drawer's shortcut tiles cut at the first comma or conjunction; the mega
// and the department list keep the full name.
export const shortLabel = (label: string) =>
  label
    .replace(/,.*$/, "")
    .replace(/\s+y\s+.*$/i, "")
    .trim()
